// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__337qx","newExpiryDate":"styles_newExpiryDate__3x9Ed","footer":"styles_footer__3hjyX"};